/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { MiscellaneousProductDropdownResponseDto } from '../model/miscellaneousProductDropdownResponseDto';
import { MiscellaneousProductPaginationResponseDto } from '../model/miscellaneousProductPaginationResponseDto';
import { MiscellaneousProductRequestDto } from '../model/miscellaneousProductRequestDto';
import { MiscellaneousProductResponseDto } from '../model/miscellaneousProductResponseDto';
import { ValidationError } from '../model/validationError';

export enum miscellaneousProductsDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum miscellaneousProductsGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum miscellaneousProductsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class MiscellaneousProductsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<Array<MiscellaneousProductDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/miscellaneous-products/dropdown`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<MiscellaneousProductPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/miscellaneous-products`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/miscellaneous-products/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsIdGet$(id: string, language?: string): Observable<MiscellaneousProductResponseDto> {
    return this.api.get(`${apiBaseUrl()}/miscellaneous-products/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsIdPut$(id: string, body: MiscellaneousProductRequestDto): Observable<MiscellaneousProductResponseDto> {
    return this.api.put(`${apiBaseUrl()}/miscellaneous-products/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/miscellaneous-products/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public miscellaneousProductsPost$(body: MiscellaneousProductRequestDto): Observable<MiscellaneousProductResponseDto> {
    return this.api.post(`${apiBaseUrl()}/miscellaneous-products`, body, undefined);
  }
}
